import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { InventoryServiceLevel } from '@domain/inventory/models/InventoryServiceLevel';
import { ProductFilter } from '@domain/product/models/ProductFilter';

export function useInventoryServiceLevel(filter?: ProductFilter) {
  const {
    data: serviceLevel,
    isLoading,
    error,
  } = useQuery<InventoryServiceLevel>({
    queryKey: ['inventoryServiceLevel', filter],
    queryFn: async () => {
      const result = await container.inventoryRepository.getInventoryServiceLevel(filter);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
  });

  return {
    serviceLevel,
    isLoading,
    error,
  };
}
